<div *ngIf="show">
  <a (click)="deleteDetailOfReport.emit()" class="link">
    <img src="/assets/delete.svg" />
  </a>
</div>
